<template>
  <div id="app">
    <router-view :key="$route.path + $route.query.ht" />
    <!-- <SystemAlert 
      :visible="showSystemAlert" 
      @confirm="hideSystemAlert"
    /> -->
  </div>
</template>

<script>
// import SystemAlert from '@/components/SystemAlert/Index.vue'

export default {
  components: {
    // SystemAlert
  },
  data() {
    return {
      // showSystemAlert: false
    }
  },
  mounted() {
    // this.checkAndShowAlert();
  },
  watch: {
    $route: {
      handler: function() {
        this.pageChange();
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    pageChange() {
      if (window.history && window.history.pushState) {
        $(window).on("popstate", function() {
          location.reload();
          //do something...
        });
      }
    },
    // checkAndShowAlert() {
    //   // 累计最多显示 3 次
    //   const count = parseInt(localStorage.getItem('systemAlertCount') || '0', 10);
    //   if (count < 3) {
    //     localStorage.setItem('systemAlertCount', String(count + 1));
    //     setTimeout(() => {
    //       this.showSystemAlert = true;
    //     }, 500);
    //   }
    // },
    // hideSystemAlert() {
    //   this.showSystemAlert = false;
    // }
  }
};
</script>

<style lang="css">
body .el-table th.gutter {
  display: table-cell !important;
}
</style>
